const d = new Date().getHours()
export default {
  version: '1.0',
  //api_url:    'http://127.0.0.1:3000',
  api_url: process.env.REACT_APP_SHOP_API,
  storefront_url: process.env.REACT_APP_CMS_API,
  navigation: {
    pageTitle: 'Bartscher AG eCommerce Backend',
    customerName: 'Bartscher AG',
    defaultLanguage: 'de',
    languages: ['de', 'fr'],
  },
  theme: {
    dark: d + 1 > 20 || d + 1 < 6, // d is UTC
  },
  languages: [
    { key: 1, text: 'Deutsch', value: 'de' },
    { key: 2, text: 'Französisch', value: 'fr' },
  ],
  icons: {
    productStatusActive: { name: 'circle', color: 'green' },
    productStatusInactive: { name: 'lock' },
    productStatusArchived: { name: 'lock', color: 'orange' },
    productStatusDeleted: { name: 'delete', color: 'orange' },
    product: { name: 'folder', color: 'blue' },
    productFamily: { name: 'folder open outline', color: 'blue' },
    productFamilyMember: { name: 'folder outline', color: 'blue' },
    userStatus: { name: 'lock' },
    userInactive: { name: 'lock' },
    userArchived: { name: 'lock', color: 'orange' },
    userDeleted: { name: 'delete', color: 'orange' },
    dealerInactive: { name: 'lock' },
    dealerArchived: { name: 'lock', color: 'orange' },
    dealerDeleted: { name: 'delete', color: 'orange' },
    dealerTypeDealer: { name: 'user', color: 'blue' },
    dealerTypeBOP: { name: 'user', color: 'red' },
    dealerTypeShop: { name: 'user outline', color: 'blue' },
    dealerTypeAdmin: { name: 'user', color: 'orange' },
    dealerTypeUser: { name: 'user', color: 'grey' },
    onlineDealerList: {name: 'list alternate outline', color: 'orange'},
    bopConfigured: {name: 'shopping cart', color: 'grey'},
    bopBaseData: {name: 'shopping cart', color: 'black'},
    bopValidated: {name: 'shopping cart', color: 'orange'},
    modalDelete: { name: 'trash outline' },
    modalApprove: { name: 'thumbs up' },
    modalCancel: { name: 'cancel' },
    mailRead: { name: 'circle outline', color: 'grey' },
    mailUnread: { name: 'circle', color: 'blue' },
    orderDone: { name: 'circle outline', color: 'grey' },
    orderOpen: { name: 'circle', color: 'orange' },

    filter: { name: 'filter' },
    attach: { name: 'attach' },
    add: { name: 'plus', color: 'blue' },
    cancel: { name: 'cancel', color: 'red' },
    confirm: { name: 'checkmark', color: 'green' },
    save: { name: 'save', color: 'blue' },
    delete: { name: 'trash outline', color: 'red' },
    discount: { name: 'gift', color: 'orange', size: 'large' },
    draggable: { name: 'sort' },
    edit: { name: 'pencil', color: 'blue' },
    locked: { name: 'lock', color: 'orange' },
    unlink: { name: 'unlinkify', color: 'red' },
    warning: { name: 'warning sign', color: 'grey' },
  },
  semantic_ui: {
    primary_color: 'orange',
  },
  format: {
    date: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    date_time: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    },
    currency: {
      CHF: {
        style: 'currency',
        currency: 'CHF',
      },
    },
  },
  nodes: {
    properties: 'admin/products/properties',
    products: 'admin/products/product',
    product: '/de/admin/products/product/',
    discount: '/de/admin/products/discounts/',
    discounts: 'admin/products/discounts',
    contactRequest: '/de/admin/inbox/contact-requests/',
    contactRequests: 'admin/inbox/contact-requests',
    dealer_order: '/de/admin/inbox/dealer_orders/',
    customer_order: '/de/admin/inbox/customer_orders/',
    dealer_orders: 'admin/inbox/dealer_orders',
    customer_orders: 'admin/inbox/customer_orders',
    dealer: '/de/admin/accounts/dealers/',
    dealers: 'admin/accounts/dealers',
    todo: '/de/admin/todos/',
    todos: 'admin/todos',
    category: '/de/admin/products/categories/',
    categories: 'admin/products/categories',
    orderRequest: '/de/admin/inbox/order-requests/',
    orderRequests: 'admin/inbox/order-requests',
    user: '/de/admin/accounts/users/',
    users: 'admin/accounts/users',

    dealersFromDashboard: '/de/admin/accounts/users',
    ordersFromDashboard: '/de/admin/inbox/orders',
    orderRequestsFromDashboard: '/de/admin/inbox/order-requests/',
    dealersCompare: '/de/admin/accounts/compare/',
    dealersImport: '/de/admin/accounts/import/',
    productsFromDashboard: '/de/admin/products/product',
    productCompare: '/de/admin/products/compare/',
    productImport: '/de/admin/products/import/',

    dashboard: '/de/admin/dashboard',
    login: '/de/user/login',
  },
}



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 10
// module chunks = 0